import Vue from 'vue'
import VueRouter from 'vue-router'
import stores from "../store/index";
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/pc/page/Home')
  },
  {
    path: '/CompanyIntro',
    name: 'CompanyIntro',
    component: () => import('@/views/pc/page/CompanyIntro')
  },  //公司介绍
  {
    path: '/HardwareEquipment',
    name: 'HardwareEquipment',
    component: () => import('@/views/pc/page/HardwareEquipment')
  },  //硬件设备
  {
    path: '/Payment',
    name: 'Payment',
    component: () => import('@/views/pc/page/Payment')
  },  //解决方案
  {
    path: '/Solution',
    name: 'Solution',
    component: () => import('@/views/pc/page/Solution')
  },  //支付
  {
    path: '/InternetHospital',
    name: 'InternetHospital',
    component: () => import('@/views/pc/page/InternetHospital')
  },  //互联网医院
  {
    path: '/SchoolVision',
    name: 'SchoolVision',
    component: () => import('@/views/pc/page/SchoolVision')
  },  //视光学院
  {
    path: '/SoftwareHome',
    name: 'SoftwareHome',
    component: () => import('@/views/pc/page/SoftwareHome')
  },  //软件系统
  {
    path: '/SoftWareYM',
    name: 'SoftWareYM',
    component: () => import('@/views/pc/page/software/SoftWareYM'),
    children: [
      {
        path: '/OphthalmicSystem',
        name: 'OphthalmicSystem',
        component: () => import('@/views/pc/page/software/OphthalmicSystem'),
      },//智慧眼科 诊疗系统
      {
        path: '/SCRM',
        name: 'SCRM',
        component: () => import('@/views/pc/page/software/SCRM')
      },  //智能营销 SCRM
      {
        path: '/EHR',
        name: 'EHR',
        component: () => import('@/views/pc/page/software/EHR')
      },  //电子病历
      {
        path: '/AIDiagnosis',
        name: 'AIDiagnosis',
        component: () => import('@/views/pc/page/software/AIDiagnosis')
      },  //眼科AI辅助诊断/处方
      {
        path: '/ERP',
        name: 'ERP',
        component: () => import('@/views/pc/page/software/ERP')
      },  //ERP
      {
        path: '/HNIS',
        name: 'HNIS',
        component: () => import('@/views/pc/page/software/HNIS')
      },  //远程手术诊疗系统
      {
        path: '/FittSystem',
        name: 'FittSystem',
        component: () => import('@/views/pc/page/software/FittSystem')
      },  //无人值守AI验配系统
      {
        path: '/ControlSystem',
        name: 'ControlSystem',
        component: () => import('@/views/pc/page/software/ControlSystem')
      },  //校医联盟 近视防控系统
      {
        path: '/ReportSystem',
        name: 'ReportSystem',
        component: () => import('@/views/pc/page/software/ReportSystem')
      },  //运营大数据智能报告系统
      {
        path: '/CareSystem',
        name: 'CareSystem',
        component: () => import('@/views/pc/page/software/CareSystem')
      },  //24小时呵护云诊视系统
    ]
  },
  {
    path: '/Register',
    name: 'Register',
    component: () => import('@/views/pc/page/Register')
  },  //注册 ViewAudit.vue
  {
    path: '/ViewAudit',
    name: 'ViewAudit',
    component: () => import('@/views/pc/page/ViewAudit'),
  },  //查看审核
  {
    path: '/VersionDifferent',
    name: 'VersionDifferent',
    component: () => import('@/views/pc/page/VersionDifferent')
  },  //版本区分
  {
    path: '/Product',
    name: 'Product',
    component: () => import('@/views/pc/page/Product')
  },  //产品介绍
  {
    path: '/PCProduct',
    name: 'PCProduct',
    component: () => import('@/views/pc/page/PCProduct')
  },  //产品介绍 PCProduct
  {
    path: '/Introduce',
    name: 'Introduce',
    component: () => import('@/views/pc/page/Introduce')
  },  //介绍
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name == 'Register' || to.name == 'Payment' || to.name == 'ViewAudit'   || to.name == 'VersionDifferent' || to.name == 'Product' || to.name == 'PCProduct' || to.name == 'ViewAudit') {
    stores.commit('isShow/upTops', false)
  }else {
    stores.commit('isShow/upTops', true)
  }
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    if(to.name !== 'PCProduct') {
      window.location.href = '/move.html#' + to.fullPath
      return
    }
  }
  next()
})

export default router
